import { render, staticRenderFns } from "./SalesOrderChangeHistory.vue?vue&type=template&id=2426d88e&"
import script from "./SalesOrderChangeHistory.vue?vue&type=script&lang=js&"
export * from "./SalesOrderChangeHistory.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderChangeHistory.vue?vue&type=style&index=0&id=2426d88e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports